export const PRICE_FREQUENCY = {
  ONE_TIME: "ONE_TIME",
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
  YEARLY: "YEARLY",
} as const;

export type PriceFrequency =
  (typeof PRICE_FREQUENCY)[keyof typeof PRICE_FREQUENCY];

export const priceFrequencyOptions = [
  { label: "One-time", value: PRICE_FREQUENCY.ONE_TIME },
  { label: "Monthly", value: PRICE_FREQUENCY.MONTHLY },
  { label: "Quarterly", value: PRICE_FREQUENCY.QUARTERLY },
  { label: "Yearly", value: PRICE_FREQUENCY.YEARLY },
];

export const PRICE_FREQUENCY_LABEL: Record<PriceFrequency, string> = {
  [PRICE_FREQUENCY.ONE_TIME]: "One-time",
  [PRICE_FREQUENCY.MONTHLY]: "Monthly",
  [PRICE_FREQUENCY.QUARTERLY]: "Quarterly",
  [PRICE_FREQUENCY.YEARLY]: "Yearly",
};
